export default {
  date: {
    days: {
      sunday: 'domingo',
      monday: 'lunes',
      tuesday: 'martes',
      wednesday: 'miércoles',
      thursday: 'jueves',
      friday: 'viernes',
      saturday: 'sábado'
    },
    daysShort: {
      sun: 'dom',
      mon: 'lun',
      tue: 'mar',
      wed: 'mié',
      thu: 'jue',
      fri: 'vie',
      sat: 'sáb'
    },
    months: {
      januray: 'enero',
      february: 'febrero',
      march: 'marcha',
      april: 'abril',
      may: 'mayo',
      june: 'junio',
      july: 'julio',
      august: 'agosto',
      september: 'septiembre',
      october: 'octubre',
      november: 'noviembre',
      december: 'diciembre'
    },
    monthsShort: {
      jan: 'ene',
      feb: 'feb',
      mar: 'mar',
      apr: 'abr',
      jun: 'jun',
      jul: 'jul',
      aug: 'ago',
      sep: 'set',
      oct: 'oct',
      nov: 'nov',
      dec: 'dic'
    }
  }
};